import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var VideoClipIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M21.347 8.583l-17.496.085v-.512l17.588-.854c.366 0 .641-.342.641-.684l-.183-3.246c-.092-.854-.825-1.452-1.74-1.452l-16.672.854c-.916 0-1.649.769-1.557 1.623l.091 7.432v7.945c0 1.28 1.1 2.306 2.474 2.306h15.114c1.374 0 2.473-1.025 2.473-2.306V9.266c0-.341-.275-.683-.733-.683zm-8.06-2.563l-2.107.086.274-2.05 2.107-.086-.275 2.05zm2.38-2.135l2.29-.086-.274 2.05-2.29.086.275-2.05zM9.074 6.19l-2.199.086.275-2.05 2.198-.086-.274 2.05zm11.083-.512h-.366l.275-2.05.091 2.05zM3.76 4.483l1.282-.086-.275 2.05H3.76V4.483zM20.248 19.26c0 .598-.55 1.025-1.1 1.025H5.043c-.641 0-1.099-.512-1.099-1.025v-8.457c0-.256.183-.513.458-.513l15.389-.085c.275 0 .458.17.458.427v8.628z"
                        }),
                        _jsx("path", {
                            d: "M14.658 14.457l-3.483-1.832c-.458-.25-1.008.083-1.008.5v3.664c0 .5.55.75 1.008.5l3.482-1.833c.459-.166.459-.75 0-.999z"
                        })
                    ]
                })
            })
        ]
    });
};
VideoClipIcon.isCarinaIcon = true;
export default VideoClipIcon;
